import style from './producthome.module.css'
import rightImage from '../../Assets/products/v1_83.png'
import lefttImage from '../../Assets/products/v1_65.png'
import playIcon from '../../Assets/products/602kss3h_expires_30_days.png'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'



export default function Producthome() {
  const [products, setProducts] = useState([]);
  const [featuredProduct, setFeaturedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://api.nasrollah.info/fa/?function=getLatestProductions');
        
        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }
        
        const data = await response.json();
        
        if (data && data.length > 0) {
          setFeaturedProduct(data[0]); 
          setProducts(data.slice(1, 7)); 
        }
        
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  // Loading
if (loading) {
  return (
    <div className={style.products}>
      <div className={style.container}>
        <div className={style.stateBox}>
          <div className={style.loader}></div>
          <div className={style.stateText}>در حال بارگذاری محصولات...</div>
        </div>
      </div>
    </div>
  );
}

if (error) {
  return (
    <div className={style.products}>
      <div className={style.container}>
        <div className={style.stateBox}>
          <div className={style.stateText}>خطا در بارگذاری: {error}</div>
        </div>
      </div>
    </div>
  );
}

// No data
if (!featuredProduct && products.length === 0) {
  return (
    <div className={style.products}>
      <div className={style.container}>
        <div className={style.stateBox}>
          <div className={style.stateText}>هیچ محصولی موجود نیست</div>
        </div>
      </div>
    </div>
  );
}

const gregorianToPersianYear = (gregorianYear) => {
  return gregorianYear - 621;
};

const extractAndConvertYear = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    const gregorianYear = date.getFullYear();
    return gregorianToPersianYear(gregorianYear);
  }
  
  return '';
};

  return (
    <div className={style.products}>
      <div className={style.container}>
        {/* Featured Product (Right side) */}
        {/* /:year/:slug/:id */}
        {/* {console.log(featuredProduct.id_post)} */}
        {featuredProduct && (
          <Link className={style.right} to={`/productions/${extractAndConvertYear(featuredProduct.create_time_post)}/${featuredProduct.slug_post}/${featuredProduct.id_post}`}>
          <div>  
            <img 
              className={style.cover} 
              src={featuredProduct.featured_post } 
              alt={featuredProduct.title || 'محصول ویژه'}
              onError={(e) => {
                e.target.src = featuredProduct.featured_image;
              }}
            />
            <div className={style.playicon}>
              <img src={playIcon} alt='پخش' />
            </div>
            {/* <div className={style.title}>
              <span className={style.subspan}>
                {featuredProduct.title_post}
              </span>
            </div> */}
          </div>
          </Link>
        )}

        {/* Product List (Left side) */}
        <div className={style.left}>  
          {products.map((product, index) => (
            <Link key={product.id || index} className={style.subproduct} to={`/productions/${extractAndConvertYear(product.create_time_post)}/${product.slug_post}/${product.id_post}`}>
              <img 
                className={style.subcover} 
                src={product.featured_post} 
                alt={product.title || `محصول ${index + 1}`}
                onError={(e) => {
                  e.target.src = featuredProduct.featured_image;
                }}
              />
              <div className={style.playiconleft}>
                <img src={playIcon} alt='پخش' />
              </div>
              {/* <div className={style.subtitle}>
                <span className={style.subspan}>
                  {product.title_post}
                </span>
              </div> */}
            </Link>
          ))}

          {products.length < 6 && 
            Array.from({ length: 6 - products.length }, (_, index) => (
              <div key={`empty-${index}`} className={style.subproduct}>
                <img className={style.subcover} src={featuredProduct.featured_image} alt='محصول' />
                <div className={style.playiconleft}>
                  <img src={playIcon} alt='پخش' />
                </div>
                <div className={style.subtitle}>
                  <span className={style.subspan}>محصول موجود نیست</span>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}